import React, { useState } from "react";
import { Table, Form } from "react-bootstrap";

const GLXTTEST = ({ output }) => {
  return (
    <div>
      {output?.filter(item => item.name && item.table && item.table.length > 0)
        .map((tableItem, idx) => {
          const tableData = tableItem.table;
          const headers = Object.keys(tableData[0]);
          return (
            <div key={idx} className="mb-3">
              <div className="text-center">
                <Form.Label className="mb-2 fw-bold" style={{ fontSize: 12 }}>{tableItem.name}</Form.Label>
              </div>
              <Table className="m-0 border-start border-end custom-table" bordered hover striped>
                <thead>
                  <tr>
                    {headers.map(header => (
                      <th key={header}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, rowIdx) => (
                    <tr key={rowIdx}>
                      {headers.map(header => (
                        <td key={header}>
                          {Array.isArray(row[header]) ? row[header].join(", ") : row[header]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          );
        })}
    </div>
  );
};

export default GLXTTEST;
